'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _count2 = require('./internal/_count');

var _count3 = _interopRequireDefault(_count2);

var _has2 = require('./internal/_has');

var _has3 = _interopRequireDefault(_has2);

var _curry = require('./curry');

var _curry2 = _interopRequireDefault(_curry);

var _getIn = require('./getIn');

var _getIn2 = _interopRequireDefault(_getIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getInOp = _getIn2.default.operation;

function hasIn(keyPath, subject) {
  var keyLen = (0, _count3.default)(keyPath);
  if (keyLen === 0) {
    return false;
  }

  var parent = getInOp(keyPath.slice(0, -1), subject);
  if (parent === undefined) {
    return false;
  }

  return (0, _has3.default)(keyPath[keyLen - 1], parent);
}

/**
 * Returns `true` if `keyPath` is defined in a nested data structure.
 *
 * `hasIn` short circuts and returns `false` when it encounters a `null` or `undefined` value.
 *
 * @example
 * const hasFirstName = hasIn(['name', 'first']);
 * const user = UserRecord({
 *   name: Map({
 *     first: 'Test',
 *     last: 'Testerson',
 *   }),
 * });
 * hasFirstName(user) === true
 *
 * @param  {Array<string>} keyPath
 * @param  {Array|Iterable|Object} subject
 * @return {boolean}
 */
exports.default = (0, _curry2.default)(hasIn);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.3/hasIn.js
// module id = 356
// module chunks = 0 1